import { useCallback } from 'react'
import styled from 'styled-components'

const Container = styled.div<{ active?: boolean }>`
  width: 8px;
  height: 8px;
  background: ${(props) => props.active ? '#49E69B' : '#525C7D'};
  border-radius: 2px;
  cursor: pointer;

  ${(props) => props.active && `
    box-shadow: 0px 0px 25px 4px rgba(73, 230, 155, 0.25);
  `}
`

interface PaginationDotProps {
  active?: boolean
  setPage: (page: number) => void
  page: number
}

const PaginationDot = ({ active, setPage, page }: PaginationDotProps) => {
  const changePage = useCallback(() => {
    console.log('page: ', page)
    setPage(page)
  }, [page, setPage])

  return (
    <Container active={active} onClick={changePage}/>
  )
}

export default PaginationDot
